import { useEffect, useState } from 'react';

export const useEffectFirstSkip = (callback: () => void, dependencies: any[]) => {
  const [isFirst, setIsFirst] = useState(true);

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false);
      return;
    }
    callback();
  }, dependencies);
};
